// Exports
export default {
	"root": "root_3V9Oa",
	"fullscreenButtonOverride": "fullscreenButtonOverride_BYMo0"
};
